import {GameAvalancheReelsView} from 'src/avalanche/GameAvalancheReelsView';
import {
	ObjectSize,
	Position,
	ReelConstants,
	Scale,
	SymbolPosition,
} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {AvalancheReel} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReel';
import {TopAvalancheReel} from 'src/topreels/TopAvalancheReel';
import {Tween} from '@fantasmagames/core/src/tween/Tween';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {PrototypeWinLine} from '@fantasmagames/slot/src/logic/prototype/PrototypeSpinResult';

export class TopReelsView extends GameAvalancheReelsView {
	protected setupReelSetMaskForSpinning(): void {
		if (this.resources.hasMajorPerformanceCaveat) {
			this._currentMask = null;

			return;
		}

		this._currentMask = new PIXI.Graphics();

		const scale: Scale = this.layout.getScale('TOP_REEL_MASK');
		const noScaleSize: ObjectSize = this.layout.getSize('TOP_REEL_MASK');
		const maskSize: ObjectSize = {width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y};
		const maskPos: Position = this.layout.getAbsolutePosition('TOP_REEL_MASK');

		this._currentMask.drawRect(0, 0, 1, 1);

		this._currentMask.x = maskPos.x - maskSize.width / 2;
		this._currentMask.y = maskPos.y - maskSize.height / 2;
		this._currentMask.width = maskSize.width;
		this._currentMask.height = maskSize.height;
	}

	protected setupLayers(): void {
		this.container.children.length = 0;
		this._reels = [];

		this._reelsetContainer = new PIXI.Sprite();

		this.container.addChild(this._reelsetContainer);

		this.container.addChild(this._currentMask);

		this.container.mask = this._currentMask;
	}

	protected createReel(reelIndex: number, startReelPosition: number, offsets: SymbolPosition, container: PIXI.Sprite): AvalancheReel {
		return new TopAvalancheReel(reelIndex, startReelPosition, offsets, container);
	}

	public fillVoidAfterRemoval(): void {
		this._wasFillingVoidMessageSent = false;
		for (let reelIndex = 0; reelIndex < ReelConstants.REELS_AMOUNT; reelIndex++) {
			this._reels[reelIndex].dropElementsToFillVoids();
		}

		if (!this.hasAnyReelsToFillVoid()) {
			this.onFillingVoidsFinished(0);
		}
	}

	public fadeOutSymbols(): void {
		const fadeOutTween: Tween = new Tween(this._reelsetContainer)
			.to({alpha: 0}, AvalancheReelsView.FADING_TIMER)
			.onComplete(() => {
			})
			.start();
		this.updateManager.add(fadeOutTween);
	}

	public fadeInSymbols(): void {
		const fadeOutTween: Tween = new Tween(this._reelsetContainer)
			.to({alpha: 1}, AvalancheReelsView.FADING_TIMER)
			.onComplete(() => {
			})
			.start();
		this.updateManager.add(fadeOutTween);
	}

	public addWinIndicationToSymbols(winLines: PrototypeWinLine[]): void {

	}

	protected tryToPlayScatterAnimationOnReel(reelIndex: number): void {

	}

	public removeSymbolsOnAvalancheWithSound(symbols: SymbolPosition[], win: number, bet: number): void {
		let lastReelWithRemovedSymbols: number = 0;

		symbols.forEach((symPos: SymbolPosition) => {
			if (symPos.x > lastReelWithRemovedSymbols) {
				lastReelWithRemovedSymbols = symPos.x;
			}
		});

		for (let reelIndex = 0; reelIndex < ReelConstants.REELS_AMOUNT; reelIndex++) {
			const symbolsOnReel: SymbolPosition[] = this.getAllSymbolPositionsFromReel(reelIndex, symbols);
			if (symbolsOnReel.length) {
				this._reels[reelIndex].removeAvalancheSymbols(symbolsOnReel, null);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/topreels/TopReelsView.ts